import { Button } from "~/components/ui/button";
import {
  ChevronDown,
  SlidersHorizontal,
} from "lucide-react";
import { MultiSelect } from "~/components/blocks/MultiSelectDropdown/MultiSelectDropdown";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@radix-ui/react-popover";

import { ToggleGroup, ToggleGroupItem } from "~/components/ui/toggle-group";
import { filterOptions, OFFICE_TYPES, } from "../Geosearch/constants";
import { ClientOnly } from "~/components/blocks/ClientOnly/client-only";
import AutoPlaces from "../Geosearch/AutoPlaces";
import { Workspace } from "../Geosearch/interfaces";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "~/components/ui/dropdown-menu";

export async function loader({ params }: { params: any }) {
  const googleMapKey = process.env.PUBLIC_REMIX_GOOGLE_MAP;
  // Replace with your API endpoint

  return { googleMapKey: googleMapKey };
}


export default function SearchBar({
  toggleDrawer,
  rightWidth,
  callGeoSearch,
  filterData,
  setFilterData,
  query = '',
  selectedSort,
  setSelectedSort,
  isCampaignPage
}: {
  toggleDrawer: VoidFunction;
  setWidth: Function;
  rightWidth: number;
  setDisplayMode: Function;
  callGeoSearch: Function,
  filterData: any,
  setFilterData: Function,
  query: string,
  displayMode: string,
  workspace: Workspace,
  setMapLoaded?: Function,
  className?: string
  selectedSort: string;
  setSelectedSort: Function;
  isCampaignPage?: boolean;
}) {

  function parseSearchUrl(url: string) {
    const [path, queryString] = url.split('?');
    const pathParts = path.split('/').filter(Boolean); // removes empty parts

    const [country, section, state, city] = pathParts;

    const queryParams = Object.fromEntries(new URLSearchParams(queryString));

    return {
      country,
      section,
      state,
      city,
      ...Object.fromEntries(
        Object.entries(queryParams).map(([key, value]) => {
          const num = parseFloat(value);
          return [key, isNaN(num) ? value : num];
        })
      )
    };
  }

  const handleLocationSelect = (location: string) => {
    callGeoSearch(parseSearchUrl(location))
  };

  return (
    <div>
      <div className="relative flex w-full justify-between">
        <div className='h-10 max-[1000px]:w-full min-h-10 flex absolute top-0 left-0 z-10  '>

          <MultiSelect
            options={OFFICE_TYPES}
            onValueChange={function (value: string[]): void {
              callGeoSearch({ workspaceType: value.join(',') })
            }}
            defaultValue={filterData.officeTypes}
            className="rounded-tr-none rounded-br-none border-r-0 hover:bg-white hover:border-r"
          />

        </div>
        <ClientOnly>{() => <AutoPlaces focus={false} onLocationSelect={handleLocationSelect} inputStyleClassName=' pl-48 z-0' />}</ClientOnly>

        <div className='flex items-center gap-2 ml-2'>
          {/* Filter Button */}
          <Button variant='outline' size='icon' onClick={toggleDrawer}>
            <SlidersHorizontal className='h-5 w-5' aria-label="Filter menu" />
          </Button>
          {!isCampaignPage && (
            <Button
              onClick={() => {
                if (filterData.promo) {
                  setFilterData({ ...filterData, promo: '' })
                  callGeoSearch({ promo: '' })
                } else {
                  setFilterData({ ...filterData, promo: 'sale' })
                  callGeoSearch({ promo: 'sale' })
                }
              }}
              variant='outline' className={`px-4 ${filterData.promo ? 'bg-oh-secondary text-white' : 'bg-white text-black'} `}>
              Sale
            </Button>
          )}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="flex items-center gap-2 focus-visible:shadow-none">
                <span className="" >Sort by:</span>
                {rightWidth === 30 && <span className={`font-medium ${rightWidth === 30 ? 'underline' : ''}`}>{selectedSort.label}</span>}
                <ChevronDown className="w-4 h-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="z-[1000] bg-white p-3 w-72 rounded-lg border mt-2 shadow-lg">
              {filterOptions.map((option) => (
                <DropdownMenuItem key={option.label} style={{ fontWeight: option.label === selectedSort?.label ? 'bold' : 'normal' }} className=" rounded-lg outline-none hover:bg-gray-100 hover:font-bold p-2 cursor-pointer" onClick={() => {
                  setSelectedSort(option);
                  callGeoSearch({ sortBy: option.value, order: option.order })
                }}>
                  {option.label}
                </DropdownMenuItem>

              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>

    </div >
  );
}
